const tutorialsHeroSection = $('#hero-section');

const addTutorialsHeroIn = () => {
  const heroDescription = tutorialsHeroSection.find('.hero-section-descriptor');
  const heroTitle = tutorialsHeroSection.find('.hero-section-title');
  const heroVideo = tutorialsHeroSection.find('.hero-video-preview-parent');
  const heroDescriptorCard = tutorialsHeroSection.find('.descriptor-card');
  const heroBtn = tutorialsHeroSection.find('.button-parent');
  const scrollHandler = tutorialsHeroSection.find('.scroll-handle');
  const lineParent = tutorialsHeroSection.find('.hero-line-parent');

  const lineTL = addLoopLineAnimation(lineParent);

  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
      lineTL.play();
    },
  });

  heroTL.addLabel('step1');
  heroTL.add(addBigTitleAnimation(heroTitle, 150, 0.9, 0.15).play(), 'step1+=0.5');
  heroTL.add(addElementInAnimation(heroVideo, '100%', 0.9, 0).play(), 'step1+=0.8');
  heroTL.add(addElementInAnimation(heroDescription, '1000%', 0.9, 0).play(), 'step1+=0.5');
  heroTL.add(addElementInAnimation(scrollHandler, '200%', 0.667, 0).play(), 'step1+=0.95');
  heroTL.add(addDescriptorCardAnimation(heroDescriptorCard, '100%', 0.667, 0).play(), 'step1+=0.9');
  heroTL.add(addBtnAnimation(heroBtn).play(), 'step1+=1.5');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), 'step1+=2.13');

  return heroTL;
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  const educatorsHeroTL = addTutorialsHeroIn();
  pageIn(educatorsHeroTL, nav);
  openStoryboardFromURL();
});
